import { useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import type { ReturnRequestDto } from "../generated/schema";

interface UseUnassignUserToReturnProps {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
	onError?: (error: Error) => void;
}

export default function useUnassignUserToReturn({
	onSuccess,
	onError,
}: UseUnassignUserToReturnProps) {
	const errorNotification = useFormErrorNotification();
	const mutation = $api.useMutation(
		"delete",
		"/shops/{shopId}/return-requests/{returnRequestId}/assigned-users",
	);

	return {
		mutateAsync: async ({
			shopId,
			returnRequestId,
			userIds,
		}: {
			shopId: string;
			returnRequestId: string;
			userIds: string[];
		}) => {
			try {
				const result = await mutation.mutateAsync({
					params: { path: { shopId, returnRequestId } },
					body: {
						assignedUserIds: userIds,
					},
				});
				onSuccess(result as ReturnRequestDto);
				return result;
			} catch (error) {
				errorNotification();
				onError?.(error as Error);
				throw error;
			}
		},
	};
}
